import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../../constants/common'
import { getMockListingViewings } from '../../../../RentalPortalListingViewings.mocks'
import { LISTING_VIEWINGS_PAGE_SIZE } from '../../RentalPortalListingProfileViewings.constants'

// TODO: move onto useTableLoader once the tab reads a served list
export function useListingProfileViewings({ listingId }) {
  const [page, setPage] = useState(1)
  const [reloadKey, setReloadKey] = useState(0)

  const [response, setResponse] = useState(null)
  const [hasError, setError] = useState(false)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoading, setLoading] = useState(true)

  const readIdRef = useRef(0)

  function loadViewings() {
    readIdRef.current += 1

    const readId = readIdRef.current

    setLoading(true)

    getMockListingViewings({
      listing_id: listingId,
      page,
      page_size: LISTING_VIEWINGS_PAGE_SIZE,
    })
      .then(({ data }) => {
        if (readIdRef.current === readId) {
          setResponse(data)
          setError(false)
          setPage(data.pagination.page)
        }
      })
      .catch(() => {
        if (readIdRef.current === readId) {
          setError(true)
        }
      })
      .finally(() => {
        if (readIdRef.current === readId) {
          setLoading(false)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    if (listingId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- the in-flight flag flips when the read starts
      loadViewings()
    }
  }, [listingId, page, reloadKey])

  function handleSetPagination(nextPagination) {
    setPage(nextPagination.page)
  }

  async function handleRefresh() {
    setInitiated(false)
    setError(false)
    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    handleRefresh,
    handleSetPagination,
    hasError,
    isInitiated,
    isLoading,
    items: response?.results?.objects ?? EMPTY_LIST,
    pagination: {
      count: response?.pagination?.total ?? 0,
      page,
      pageCount: response?.pagination?.page_count ?? 0,
      pageSize: LISTING_VIEWINGS_PAGE_SIZE,
    },
  }
}
